import { render } from "./MRadio.vue?vue&type=template&id=b6eb5ec6&scoped=true"
import script from "./MRadio.vue?vue&type=script&lang=js"
export * from "./MRadio.vue?vue&type=script&lang=js"

import "./MRadio.vue?vue&type=style&index=0&id=b6eb5ec6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6eb5ec6"]])

export default __exports__